<template>
    <div class="first__access__main">
        <div class="top__header" />
        <section class="top__section">
            <div class="top__container">
                <div class="header__user">
                    <div class="line" />
                    <div class="welcome">
                        <img v-if="view.dashboard_data.parent.name != null" :src="this.view.dashboard_data.parent.gravatar" />
                        <span v-html="`${FatherIs()}` + view.translation.first_access.label_welcome + `<span style='color: #0080FC;'>${this.view.dados_usuario_office.nome}</span>`"></span>
                    </div>
                </div>
            </div>
        </section>
        <section class="main__section">
            <div class="colapse__content">
                <dv5-collapse-onboarding>
                    <span :slot="'title'" slot-scope="props" :class="props.titleClass">{{view.translation.dashboard.onboarding_collapse_title}}</span>
                    <div :slot="'content'" slot-scope="props" :view="props.content">
                        <social-component v-for="(card, index) in social_media" :key="index" :social="index" :view="card" :subItem="false" :translations="view.translation.dashboard"/>
                    </div>
                </dv5-collapse-onboarding>

                <!--<div class="card_open_modal" data-toggle="modal" data-target=".bd-example-modal-lg">
                    <div class="card_structure">
                        <div>
                            <span class="header_title">{{view.translation.dashboard.onboarding_modal_title}}</span>
                            <span class="header_subtitle">{{view.translation.dashboard.onboarding_modal_subtitle}}</span>
                        </div>
                        <div>
                            <img alt="teste" :src="`/internacional/public/office5/img/general-svg/play_circle_filled.svg`">
                        </div>
                    </div>
                </div>-->
            </div>
        </section>
        <section class="footer_section">
            <div class="line_separator" />
            <div class="btn_continue" @click="redirect()" v-html="`<span style='color: #FFF;'>${this.view.translation.dashboard.go_to_your_office}</span>`"></div>
        </section>
        <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" @click="onCloseModal()">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="youtube-iframe embed-responsive-item" src="https://videomng.builderall.com/embed/NSG8aNMz2L?autoplay=2&countdown=1&controls=1&allowpause=1" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "onboarding-v5",
    props: ["view"],
    data() {
        return {
            social_media: [],
        };
    },
    mounted() {
        this.social_media = this.view['url_socials']
    },
    created() {
    },
    methods: {
        FatherIs() {
            var text = '';
            if (this.view.dashboard_data.parent.name != null && this.view.dashboard_data.parent.name != undefined) {
                text = `<span style='color: #0080FC;'>${this.view.dashboard_data.parent.name}</span>` + ' ' + `${this.view.translation.first_access.label_invited}` + ', ';
            }
            return text;
        },
        redirect() {
            window.open(`${this.view.handler_routes.rota_office_index}?onboarding=1`)
        },
        onCloseModal() {
            $('.youtube-iframe').each(function(index) {
                $(this).attr('src', $(this).attr('src'));
                return false;
            });
        }
    }
}
</script>

<style>
.menu-top, .menu-top-mobile{
    display: none !important;
}
nav.menu-top,
nav.menu-top-mobile{
    display: none !important;
}
#content{
    padding: 0% !important;
}
section#main {
    min-height: 100vh !important;
}
</style>
<style lang="scss">
@import "../../../../scss/office";
@import "../../../../scss/extras/_variables";
.first__access__main {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    overflow-y: auto;
    .top__header {
        background-image: url("/internacional/public/office5/img/general-svg/logo_ba.svg");
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 45px;
        background-color: $dv5-color4;
        padding: 10px 1.66vw;
        text-align: right;
    }
    .top__section {
        background: white;
        .top__container {
            width: 100%;
            margin: 0 auto;
            .header__user {
                display: flex;
                flex-direction: column;
                align-items: center;

                .line {
                    background-color: #7070703d;
                    height: 1px;
                    width: 100%;
                    opacity: 0.6;
                }
                .welcome {
                    display: flex;
                    align-items: center;

                    margin: 1.5rem 0;
                    font-weight: bold;
                    font-family: 'Muli-Regular';
                    img {
                        border-radius: 50%;
                        overflow: hidden;
                        height: 4rem;
                        margin-right: .5em;
                        border: 4px solid $dv5-color1;
                    }
                    span {
                        color: #556677;
                        font-size: 1.2rem;
                    }
                }
            }
        }
    }
    .main__section{
        display: flex;
        justify-content: center;
        margin-top: 5rem;

        .colapse__content {
            width: 50%;

            .card_open_modal{
                transition: padding .3s;
                font: inherit;
                padding: 1em 2em;
                display: flex;
                flex-direction: column;

                .card_structure{
                    background-color: $dv5-color4;
                    border-radius: 8px;
                    padding: 1.6em;
                    display: flex;
                    flex-wrap: nowrap;
                    justify-content: space-between;
                    align-items: center;

                    &:hover{
                        cursor: pointer;
                    }
                    div{
                        .header_title{
                            font-size: 1.8em;
                            color: $dv5-color2;
                            font-weight: 800;
                            text-transform: capitalize;
                            margin-right: 0.777777778em;
                            display: inline-block;
                        }
                        .header_subtitle{
                            font-size: 1.4em;
                            color: $dv5-color3;
                            font-weight: 800;
                            display: inline-block;
                        }
                    }
                }
            }
        }
    }
    .footer_section {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 2.5rem;

        .line_separator {
            width: 50%;
            height: 1px;
            background-color: #7070703d;
        }
        .btn_continue {
            display: flex;
            align-items: center;
            justify-content: center;

            cursor: pointer;
            margin: 2.5rem 0;
            width: 47%;
            background-color: $dv5-color1;
            border-radius: 8px;

            span {
                font: inherit;
                font-size: 1.8em;
                padding: .8em;
                text-transform: capitalize;
            }
        }
    }
}
@media screen and (min-width: 1025px) and (max-width: 1366px) {
    .first__access__main {
        .main__section {
            .colapse__content {
                width: 60%;
            }
            .card_open_modal {

                .card_structure {
                    background-color: $dv5-color4;
                    border-radius: 8px;
                    padding: 1.6em 1.6em;

                    .header_subtitle {
                        margin-top: .3em;
                    }
                }
            }
        }
        .footer_section {
            .line_separator {
                width: 60%;
            }
        }
    }
}
@media screen and (min-width: 700px) and (max-width: 1024px) {
    .first__access__main {
        .main__section {
            .colapse__content {
                width: 70%;
            }
            .card_open_modal {

                .card_structure {
                    background-color: $dv5-color4;
                    border-radius: 8px;
                    padding: 1.6em 1.6em;

                    .header_subtitle {
                        margin-top: .3em;
                    }
                }
            }
        }
        .footer_section {
            .line_separator {
                width: 70%;
            }
        }
    }
}
@media screen and (min-width: 1667px) and (max-width: 1920px) {
    .first__access__main {
        .main__section {
            .colapse__content {
                width: 55%;
            }
            .card_open_modal {

                .card_structure {
                    background-color: $dv5-color4;
                    border-radius: 8px;
                    padding: 1.6em 1.6em;

                    .header_subtitle {
                        margin-top: .3em;
                    }
                }
            }
        }
        .footer_section {
            .line_separator {
                width: 55%;
            }
        }
    }
}
@media screen and (min-width: 0px) and (max-width: 700px) {
    .first__access__main {
        .main__section {
            .colapse__content {
                width: 90%;
            }
            .card_open_modal {

                .card_structure {
                    background-color: $dv5-color4;
                    border-radius: 8px;
                    padding: 1.6em 1.6em;

                    .header_subtitle {
                        margin-top: .3em;
                    }
                }
            }
        }
        .footer_section {
            .line_separator {
                width: 90%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/onboarding/onboarding-v5.vue